import { queryPersister } from '@/lib/query/queryPersister'
import type { i18n as I18n } from 'i18next'

/**
 * i18next の言語を切り替えてからページをリロードし、全 API のレスポンスを新しいロケールで取り直す。
 *
 * 呼び出し前に `{slug}_i18nextLng` へ保存しておくこと。API の `X-Local` と queryKey は
 * localStorage の値から決まるため、保存せずにリロードすると元のロケールに戻ってしまう。
 *
 * - 先に `changeLanguage()` を済ませておくと、リロード直後に旧言語の文言が一瞬表示されるのを防げる
 * - 旧ロケールで取得した永続キャッシュ（localStorage）を破棄してからリロードする。
 *   queryKey にロケールを含めているため表示はキーの分離だけで正しくなるが、
 *   破棄しないとロケール数ぶん localStorage が積み上がる（#3529）
 * - どこで失敗してもリロードは必ず行う（キーは分離済みなので表示は正しくなる）
 */
export const applyLocaleAndReload = (i18n: I18n, code: string): void => {
  void i18n
    .changeLanguage(code)
    .catch(() => {
      // 切り替えに失敗しても localStorage は保存済みのため、リロード後に反映される
    })
    .finally(() => {
      // removeClient() の戻り値は Promisable<void>（同期 no-op のこともある）ため Promise.resolve() で包んでから待つ
      void Promise.resolve(queryPersister.removeClient())
        .catch(() => {
          // localStorage が使用不可になった等。リロードして続行する
        })
        .finally(() => {
          window.location.reload()
        })
    })
}
